/** The products module's part of the admin dashboard (`dashboard.tiles` / `dashboard.tasks` slots). */

import { useQuery } from "@tanstack/react-query";

import { adminProductsCounts, adminProductsList } from "@motolynk/api-client";
import { DashboardTask } from "@motolynk/app-core";
import { useTranslation } from "@motolynk/i18n";
import { KpiTile } from "@motolynk/ui";

import { productKeys } from "./source";

const LOW_STOCK = { status: "approved" as const, stock: "low" as const, page_size: 1 };

function useCounts() {
  return useQuery({
    queryKey: productKeys.counts(),
    queryFn: async () => (await adminProductsCounts()).data,
  });
}

export function ProductsTile() {
  const { t } = useTranslation("products");
  const counts = useCounts().data;
  return (
    <KpiTile
      icon="package"
      label={t("dashboard.products")}
      value={counts ? counts.approved : "—"}
      hint={counts ? t("dashboard.productsHint", { count: counts.pending_review }) : undefined}
    />
  );
}

export function LowStockTile() {
  const { t } = useTranslation("products");
  const low = useQuery({
    queryKey: productKeys.list(LOW_STOCK),
    queryFn: async () => (await adminProductsList(LOW_STOCK)).data,
  });
  return (
    <KpiTile
      icon="alert"
      label={t("dashboard.lowStock")}
      value={low.data ? low.data.count : "—"}
      hint={t("dashboard.lowStockHint")}
    />
  );
}

export function ProductTasks() {
  const { t } = useTranslation("products");
  const counts = useCounts().data;
  const low = useQuery({
    queryKey: productKeys.list(LOW_STOCK),
    queryFn: async () => (await adminProductsList(LOW_STOCK)).data,
  });
  return (
    <>
      <DashboardTask
        to="/products?status=pending_review"
        icon="package"
        label={t("dashboard.toApprove")}
        count={counts?.pending_review}
      />
      <DashboardTask
        to="/products/compatibility"
        icon="car"
        label={t("dashboard.missingFitment")}
        count={counts?.missing_fitment}
        tone="warning"
      />
      <DashboardTask
        to="/products?status=approved&stock=low"
        icon="alert"
        label={t("dashboard.lowStock")}
        count={low.data?.count}
        tone="warning"
      />
    </>
  );
}
